<section>
  <h3 *ngIf="auth.userRol()">¡{{ user.username }} gracias por tu visita!</h3>
  <h3 *ngIf="!auth.userRol()">¡Gracias por tu visita!</h3>

  <!-- ToDo:
  <h4>¿Quieres ver nuevamente tu visita?</h4>

  <div>
    <iframe
      width="560"
      height="315"
      src="https://www.youtube.com/embed/DuDX6wNfjqc"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <div class="body-light-2 no-data">Video no disponible</div>
  </div>

  <div class="conteiner-copy-link-and-share">
    <span class="toltip-copy-text" *ngIf="statusCopy"
      >Link copiado en el portapapeles</span
    >

    <div>
      <button (click)="copyText('')" value="Copiar link">
        <span class="icon-Copy"></span>
        Copiar link
      </button>
    </div>
  </div>
  -->

  <div class="container-buttons">
    <button class="btn-without-filled" (click)="goToProject()">
      Más información del proyecto
    </button>
    <button *ngIf="auth.userRol()" class="btn-filled" (click)="goToLogin()">
      Ingresa a tu cuenta
    </button>
  </div>
</section>
